/* eslint-disable */
// 数字校验
export const validateNumber = (rule, value, callback) => {
  const numberReg = /^(\-|\+)?\d+(\.\d+)?$/
  if (value === '' || value === undefined || value === null) {
    callback()
  } else {
    if (!numberReg.test(value)) {
      callback(new Error('请输入数字'))
    } else {
      callback()
    }
  }
}
// 大于0数字
export const validateGT0 = (rule, value, callback) => {
  if (value === '' || value === undefined || value == null) {
    callback()
  } else if (Number(value)!==Number(value)) {
    callback(new Error('请输入大于0的数字'))
  } else if (value <=0 ) {
    callback(new Error('请输入大于0的数字'))
  } else {
    callback()
  }
}
// 经度校验
export const validateLongitude = (rule, value, callback) => {
  if (value === '' || value === undefined || value == null) {
    callback()
  } else if (Number(value)!==Number(value)) {
    callback(new Error('请输入[-180,180]之间的数字'))
  } else if (value < -180 || value > 180) {
    callback(new Error('请输入[-180,180]之间的数字'))
  } else {
    callback()
  }
}
// 纬度校验
export const validateLatitude = (rule, value, callback) => {
  if (value === '' || value === undefined || value == null) {
    callback()
  } else if (Number(value)!==Number(value)) {
    callback(new Error('请输入[-90,90]之间的数字'))
  } else if (value < -90 || value > 90) {
    callback(new Error('请输入[-90,90]之间的数字'))
  } else {
    callback()
  }
}
// ip地址校验
export function validateIP (rule, value, callback) {
  if (value === '' || value === undefined || value === null) {
    callback()
  } else {
    const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
    if ((!reg.test(value)) && value !== '') {
      callback(new Error('请输入正确的IP地址'))
    } else {
      callback()
    }
  }
}
// 手机号码或固话
export function validatePhoneTwo (rule, value, callback) {
  const reg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/
  if (value === '' || value === undefined || value === null) {
    callback()
  } else {
    if ((!reg.test(value)) && value !== '') {
      callback(new Error('请输入正确的电话号码或者固话号码'))
    } else {
      callback()
    }
  }
}
// 固话
export function validateTelphone (rule, value, callback) {
  const reg = /0\d{2,3}-\d{7,8}/
  if (value === '' || value === undefined || value == null) {
    callback()
  } else {
    if ((!reg.test(value)) && value !== '') {
      callback(new Error('请输入正确的固定电话）'))
    } else {
      callback()
    }
  }
}
// 手机号码
export function validatePhone (rule, value, callback) {
  const reg = /^[1][0-9][0-9]{9}$/
  if (value === '' || value === undefined || value === null) {
    callback()
  } else {
    if ((!reg.test(value)) && value !== '') {
      callback(new Error('请输入正确的电话号码'))
    } else {
      callback()
    }
  }
}
// 手机号码，admin
export function validatePhoneAdmin (rule, value, callback) {
  const reg = /^[1][0-9][0-9]{9}$/
  if (value === '' || value === undefined || value === null || value==='admin') {
    callback()
  } else {
    if ((!reg.test(value)) && value !== '') {
      callback(new Error('请输入正确的电话号码'))
    } else {
      callback()
    }
  }
}
// 身份证
export function validateIdNo (rule, value, callback) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  if (value === '' || value === undefined || value === null) {
    callback()
  } else {
    if ((!reg.test(value)) && value !== '') {
      callback(new Error('请输入正确的身份证号码'))
    } else {
      callback()
    }
  }
}
// 邮箱
export function validateEMail (rule, value, callback) {
  const reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/
  if (value === '' || value === undefined || value === null) {
    callback()
  } else {
    if (!reg.test(value)) {
      callback(new Error('请输入正确的邮箱'))
    } else {
      callback()
    }
  }
}
// url
export function validateURL (url, value, callback) {
  // const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  if (value === '' || value === undefined || value === null) {
    callback()
  } else {
    if (!value.startsWith('http://') && !value.startsWith('https://')) {
      callback(new Error('请输入网页链接'))
    } else {
      callback()
    }
  }
}
// 直播
export function validateLive (url, value, callback) {
  if (value === '' || value === undefined || value === null) {
    callback()
  } else {
    if (!value.toLowerCase().startsWith('http://') && !value.toLowerCase().startsWith('https://')) {
      callback(new Error('请输入网页链接'))
    } else if (!value.toLowerCase().indexOf('m3u8')<0 && !value.toLowerCase().indexOf('flv')<0) {
      callback(new Error('只支持m3u8,flv格式直播'))
    } else {
      callback()
    }
  }
}
// 英文及下划线
export function isPassword (rule, value, callback) {
  const reg = /^[_a-zA-Z0-9]+$/
  if (value === '' || value === undefined || value === null) {
    callback()
  } else {
    if (!reg.test(value)) {
      callback(new Error('仅由英文字母，数字以及下划线组成'))
    } else {
      callback()
    }
  }
}
// 1到20000
export function checkMax20000 (rule, value, callback) {
  if (value === '' || value === undefined || value == null) {
    callback()
  } else if (!Number(value)) {
    callback(new Error('请输入[1,20000]之间的数字'))
  } else if (value < 1 || value > 20000) {
    callback(new Error('请输入[1,20000]之间的数字'))
  } else {
    callback()
  }
}
// 中文
export const validateContacts = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入中文'))
  }
  if (!/^[\u0391-\uFFE5A-Za-z0-9]+$/.test(value)) {
    callback(new Error('不可输入特殊字符'))
  } else {
    callback()
  }
}
// 密码
export const validatePassword = (rule, value, callback) => {
  var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/;  //校验密码6-12位
  if (value === '' || value === undefined || value == null) {
    callback()
  }else if (!reg.test(value)) {
    callback(new Error('密码须包含数字、字母两种元素，且密码位数为6-12位'))
  } else {
    callback()
  }
}

// 密码校验规则2，包含大小写字母、数字、特殊字符至少2个组合大于8小于16个字符
export const validatePassword2 = (rule, value, callback) => {
  // 包含大小写字母、数字、特殊字符至少2个组合大于8小于16个字符
  var reg =  /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{8,16}$/;
  if (value === '' || value === undefined || value == null) {
    callback()
  }else if (!reg.test(value)) {
    callback(new Error('密码须包含大小写字母、数字、特殊字符至少2个组合大于8小于16个字符'))
  } else {
    callback()
  }
}
// 6位数字验证码校验
export const validateCaptcha = (rule, value, callback) => {
  const numberReg = /^[0-9]{6}$/
  if (value === '' || value === undefined || value === null) {
    callback()
  } else {
    if (!numberReg.test(value)) {
      callback(new Error('请输入6位数字'))
    } else {
      callback()
    }
  }
}
